import { render, staticRenderFns } from "./StoreQuota.vue?vue&type=template&id=747db707&scoped=true&"
import script from "./StoreQuota.vue?vue&type=script&lang=js&"
export * from "./StoreQuota.vue?vue&type=script&lang=js&"
import style0 from "./StoreQuota.vue?vue&type=style&index=0&id=747db707&scoped=true&lang=css&"
import style1 from "./StoreQuota.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747db707",
  null
  
)

export default component.exports